import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { Message } from 'semantic-ui-react';
import { UserRole } from '@upstart/harmony/lib/constants';
import SystemDown from '../../components/SystemDown/SystemDown';

const hasAccess = (user, roles) => {
  if (!roles) return true;
  const userRoles = get(user, 'roles', []);

  // Always true for ADMIN roles
  return roles
    .concat(UserRole.ADMIN, UserRole.SUPER_ADMIN, UserRole.READ_ONLY_ADMIN)
    .some((role) => userRoles.includes(role));
};

function UnauthorizedMessage() {
  return (
    <Message negative>
      <Message.Header>Unauthorized</Message.Header>
    </Message>
  );
}

function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!rest.isByPassMaintenanceMode && rest.systemStatus.isSystemDown) {
          return <SystemDown restoreDate={rest.systemStatus.restoreDate} />;
        }
        if (hasAccess(rest.user, rest.roles)) {
          return <Component {...props} {...rest.componentProps} />;
        }
        if (!rest.fetching) {
          return <UnauthorizedMessage />;
        }
        return null;
      }}
    />
  );
}

PrivateRoute.propTypes = {
  roles: PropTypes.array,
  component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

const mapStateToProps = ({ user, global }) => ({
  user: user.currentUser,
  fetching: user.fetching,
  systemStatus: global.systemStatus,
  isByPassMaintenanceMode: global.isByPassMaintenanceMode,
});

export default connect(mapStateToProps)(PrivateRoute);
